import {Idol} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/idol.types';
import {
  FONT_SIZES,
  FONT_WEIGHTS,
  Image,
  tabletAndUpLinaria,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';

export enum IdolImageSizes {
  small = 'small',
  medium = 'medium',
  large = 'large',
}

const sizesMap = {
  [IdolImageSizes.small]: FONT_SIZES.px10,
  [IdolImageSizes.medium]: FONT_SIZES.px14,
  [IdolImageSizes.large]: FONT_SIZES.px20,
};

const widthMap = {
  [IdolImageSizes.small]: '24px',
  [IdolImageSizes.medium]: '32px',
  [IdolImageSizes.large]: '40px',
};

export const ProductCollageIdolImage: React.FC<{
  profileImage: Idol['profileImage'];
  profileName: string;
  size: IdolImageSizes;
  increaseInset?: boolean;
}> = ({profileImage, profileName, size, increaseInset}) => {
  return (
    <IdolWrapper $size={size} $increaseInset={increaseInset}>
      <IdolImage
        src={profileImage.url}
        alt={profileImage.description ?? profileName}
        ratio="1:1"
        widths={[32, 56, 80]}
        breakpoints={[{columns: 8}]}
        $size={size}
      />
      {profileName}
    </IdolWrapper>
  );
};

const IdolWrapper = styled.div<{
  $size: IdolImageSizes;
  $increaseInset?: boolean;
}>`
  position: absolute;
  top: ${props => (props.$increaseInset ? '16px' : '8px')};
  left: ${props => (props.$increaseInset ? '16px' : '8px')};

  display: flex;
  align-items: center;
  gap: 10px;

  font-size: ${props => sizesMap[props.$size]};
  font-weight: ${FONT_WEIGHTS.mediumHeavy};

  padding: 4px 16px 4px 4px;
  margin-right: 8px;
  border-radius: 25px;
  background: rgba(255, 255, 255, 0.25);
  backdrop-filter: blur(2px);

  ${tabletAndUpLinaria(`
    background: rgba(255, 255, 255, 0.5);
    backdrop-filter: blur(5px);
  `)}
`;

const IdolImage = styled(Image)<{$size: IdolImageSizes}>`
  width: ${props => widthMap[props.$size]};
  border-radius: 25px;
  object-fit: cover;
`;
